import { render, staticRenderFns } from "./VentajasComp.vue?vue&type=template&id=35ed31ca&"
var script = {}
import style0 from "./VentajasComp.vue?vue&type=style&index=0&id=35ed31ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports